// export const AVATAR_API = "https://ui-avatars.com/api";
// export const API = "https://plm-backend.andamen.com/api";
// export const AUTH_TOKEN = "";
// export const BEARER = "Bearer";
// export const downloadUrl = "http://localhost:1337";

// export const AVATAR_API = "https://ui-avatars.com/api";
// export const API = "https://plm-dev-backend.andamen.com/api";
// export const AUTH_TOKEN = "";
// export const BEARER = "Bearer";
// export const downloadUrl = "https://plm-dev-backend.andamen.com";

export const AVATAR_API = `${process.env.REACT_APP_AVATAR_API}`;
export const API = `${process.env.REACT_APP_API}`;
export const AUTH_TOKEN = `${process.env.REACT_APP_AUTH_TOKEN}`;
export const BEARER = `${process.env.REACT_APP_BEARER}`;
export const downloadUrl = `${process.env.REACT_APP_DOWNLOAD_URL}`;